var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-information-address-list" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "company-information-address-list__loading-card" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "company-information-address-list__loading-card-header"
                },
                [
                  _c("CompassSkeleton", {
                    staticClass:
                      "company-information-address-list__loading-card-title",
                    attrs: { size: "x-large" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "company-information-address-list__loading-card-actions"
                    },
                    [
                      _c("CompassSkeleton", { attrs: { variant: "square" } }),
                      _vm._v(" "),
                      _c("CompassSkeleton", { attrs: { variant: "square" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "company-information-address-list__loading-card-address"
                },
                [
                  _c("CompassSkeleton"),
                  _vm._v(" "),
                  _c("CompassSkeleton"),
                  _vm._v(" "),
                  _c("CompassSkeleton")
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _vm._l(_vm.addresses, function(address) {
            return _c("AddressCard", {
              key: address.id,
              attrs: {
                context: "",
                permissions: _vm.permissions,
                address: address,
                addressUpdating: _vm.addressUpdating,
                disableSwitches: _vm.isPanelOpen
              },
              on: {
                onEdit: _vm.openAddress,
                onDelete: function($event) {
                  return _vm.deleteAddress(address)
                },
                onDeliveryAddressSwitch: function($event) {
                  return _vm.defineDeliveryAddress(address)
                },
                onInvoicingAddressSwitch: function($event) {
                  return _vm.defineInvoicingAddress(address)
                }
              }
            })
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.showDeleteModal,
            size: "small",
            title: _vm.$t.__("common.labels.delete_address_title"),
            primaryAction: _vm.primaryActionDeleteAddress,
            closeOnClickOverlay: false,
            secondaryActions: [
              {
                label: _vm.$t.__("common.actions.cancel"),
                action: function() {
                  return (_vm.showDeleteModal = false)
                }
              }
            ]
          },
          on: {
            "update:visible": function($event) {
              _vm.showDeleteModal = $event
            },
            closed: function($event) {
              _vm.showDeleteModal = false
            }
          }
        },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t.__("common.labels.delete_address_description")) +
                "\n        "
            )
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }